export const MAIN = process.env.PUBLIC_URL + "/main";
export const MY_ACCOUNT = process.env.PUBLIC_URL + "/myAccount";
export const EXERCISE_RESERVATION = process.env.PUBLIC_URL + "/exerciseReservation";
export const ACTIVE_ACCOUNT = process.env.PUBLIC_URL + "/activeAccount";
export const TICKET_SALE = process.env.PUBLIC_URL + "/ticketSale";
export const FINALIZE_PAGE = process.env.PUBLIC_URL + "/finalizePage";
export const FINALIZE_SUCCESS = process.env.PUBLIC_URL + "/finalizeSuccess";
export const SEAT_SALE = process.env.PUBLIC_URL + "/seatSale";
export const SEATS_VIEW = process.env.PUBLIC_URL + "/seatsView";
export const BASKET_TICKET = process.env.PUBLIC_URL + "/basketTicket";
export const ACCOUNT_DEFINITION = process.env.PUBLIC_URL + "/accountDefinition";
export const STRZELNICA_PAGE = process.env.PUBLIC_URL + "/strzelnica";
export const KRYTY_PAGE = process.env.PUBLIC_URL + "/kryty";